import { render, staticRenderFns } from "./main-home-en.vue?vue&type=template&id=6ed2ac14&"
import script from "./main-home-en.vue?vue&type=script&lang=js&"
export * from "./main-home-en.vue?vue&type=script&lang=js&"
import style0 from "./main-home-en.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports